<template>
  <div id="app">
    <router-view/>
    <msg-erro></msg-erro>
    <msg-sucesso></msg-sucesso>
    <loader></loader>  
  </div>
</template>

<script>

import Loader from './components/Loader.vue';
import MsgErro from './components/MsgErro.vue';
import MsgSucesso from './components/MsgSucesso.vue';

export default {
  name: 'App',
  components: {
    Loader,
    MsgErro,
    MsgSucesso
  }
}
</script>

<style scoped>
#app {
  margin-top: 0;
  margin-bottom: 0;
}
</style>

<style>
.form-group--error input, 
.form-group--error select, 
.form-group--error textarea,
.form-group--error .vs__dropdown-toggle input,
.form-group--error-file div label,
.form-group--error .vs__dropdown-toggle,
.form-group--error .b-form-datepicker
{
    border: 1px solid red !important
}
.form-group--error .vs__dropdown-toggle {
    border: 1px solid red !important
}
.form-group--error .vs__dropdown-toggle input {
    border: none !important
}
.form-group--error-file div label {
    border: 1px solid red !important
}
</style>


// WEBPACK FOOTER //
// src/App.vue